
import React from 'react'
import styled from 'styled-components'

const Styling = styled.div`
width:100vw;
height: 100vh;
background: var(--blue_dark);
position: fixed;
right:0;
top:0;
color:var(--blue_light);
z-index: 0;

    @media only screen and (min-width: 1024px) {
    width:50vw;
    }

    .image-wrapper-outer{
    position: relative;
    }

    .close{
    position: absolute;
    top:2rem;
    right:2rem;
    z-index: 10;
    cursor: pointer;
    background:var(--blue_dark);
    display: flex;
    align-items: center;
    padding:1rem;
    }

    .logo-wrapper{
    width:50px;
    height:50px;
    position:absolute;
    bottom:4rem;
    left:4rem;
    z-index: 10;
    background:white;
    display: flex;
    align-items:center;
    justify-content: center;
    padding:2rem;
    box-sizing:content-box;

        @media only screen and (min-width: 500px) {
        width: 100px;
        height: 100px;
        }
        
    }

    .image-wrapper{
    position: relative;
    padding-bottom: clamp(200px, 70%, 500px);

        .gatsby-image-wrapper{
        width: 100% !important;
        height: 100% !important;
        position: absolute !important;
        top:0 !important;
        left:0 !important;
        }

        img{
        width: 100%;
        height:100%;
        object-fit: cover;
        position: absolute;
        }

        &.topLeft{
           img{
            object-position: 0 0;
           } 
        }

        &.topCenter{
            img{
            object-position: 50% 0;
            }
        }

        &.topRight{
            img{
            object-position: 100% 0;
            }
        }

        &.middleLeft{
            img{
            object-position: 0 50%;
            }
        }

        &.middleCenter{
            img{
            object-position: 50% 50%;
            }
        }

        &.middleRight{
            img{
            object-position: 100% 50% ;
            }
        }

        &.bottomLeft{
            img{
            object-position: 0 100%;
            }
        }

        &.bottomCenter{
            img{
            object-position: 50% 100%;
            }
        }
        
        &.bottomRight{
            img{
            object-position: 100% 100%;
            }
        }
    }

    .content-wrapper{
    position: relative;
    padding:4rem;

        .title{
        position: relative;
        margin-bottom: 2rem;
        }

        .text{
        position: relative;
        
            p{
            ${({theme}) => theme.fontSize('18')}  
            ${({theme}) => theme.fontSizeLineHeight('18', '1.5')}  
            }
        }

    }

`

export { Styling }